import Component from "../../lib/component";
import stateMachine from '../online_app/instances/state_machine/index';


export default class OnlineAppComponent extends Component {

    constructor(id_or_element, onlineApp=null, config={}) {
        super({
            element: id_or_element,
            config:  config,
            stateMachine: stateMachine
        });
        this.onlineApp = onlineApp;
    }

}